import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const TopMenu = () => import("@/components/TopMenu");
const Home = () => import("@/views/Home");
const CompetitionIntroduction = () => import("@/views/CompetitionIntroduction");
const FileDownload = () => import("@/views/FileDownload");
const Register = () => import("@/views/Register");
const Recover = () => import("@/views/Recover");
const Login = () => import("@/views/Login");
const TeamMenu = () => import("@/views/TeamMenu");
const cert = () => import("@/views/cert");
const certdownload = () => import("@/views/certdownload");
const Userinfo = () => import("@/views/Userinfo");
const Upload = () => import("@/views/Upload");
const Apply = () => import("@/views/Apply");
const Score = () => import("@/views/Score");
const News = () => import("@/views/News");
const NewsDetail = () => import("@/views/NewsDetail");
const Platform = () => import("@/views/Platform");
const menuMod = () => import("@/views/menu/index");
const Leaflet = () => import("@/views/Leaflet");

const routers = [
  {
    path: "/",
    redirect: "/pc/home",
  },
  {
    name: "PC",
    path: "/pc",
    component: TopMenu,
    redirect: "/pc/home",
    meta: {},
    children: [
      {
        name: "Home",
        path: "/pc/home",
        component: Home,
      },
      {
        name: "Cintroduction",
        path: "/pc/cintroduction",
        component: CompetitionIntroduction,
      },
      {
        name: "FDownload",
        path: "/pc/fileDownload",
        component: FileDownload,
      },
      {
        name: "menuMod",
        path: "/pc/menuMod",
        component: menuMod,
        redirect: "/pc/register",
        children: [
          {
            name: "Register",
            path: "/pc/register",
            component: Register,
          },
          {
            name: "Recover",
            path: "/pc/recover",
            component: Recover,
          },
          {
            name: "Login",
            path: "/pc/login",
            component: Login,
          },
          {
            name: "Teammenu",
            path: "/pc/menu",
            component: TeamMenu,
          },
          {
            name: "Userinfo",
            path: "/pc/userinfo",
            component: Userinfo,
          },
          // {
          //     name: 'Upload',
          //     path: '/pc/upload',
          //     component: Upload,
          // },
          {
            name: "Apply",
            path: "/pc/apply",
            component: Apply,
          },
          {
            name: "Score",
            path: "/pc/score",
            component: Score,
          },
        ],
      },
      {
        name: "download",
        path: "/pc/download",
        component: menuMod,
        redirect: "/pc/cert",
        children: [
          { name: "cert", path: "/pc/cert", component: cert },
          { name: "certdownload", path: "/pc/certdownload", component: certdownload },
        ],
      },
      {
        name: "News",
        path: "/pc/news",
        component: News,
      },
      {
        name: "NewsDetail",
        path: "/pc/detail/:id?",
        component: NewsDetail,
      },
      {
        name: "Platform",
        path: "/pc/platform",
        component: Platform,
      },
    ],
  },
  {
    name: "Leaflet",
    path: "/leaflet",
    component: Leaflet,
  },
];

//添加路由对象
const router = new VueRouter({
  scrollBehavior: () => ({ y: 0 }),
  routes: routers,
});

export default router;